var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.radioTag,{ref:"radioGroup",tag:"component",attrs:{"role":"radiogroup"}},[_vm._t("default",null,{"on":_vm.handleChange})],2)}
var staticRenderFns = []

export { render, staticRenderFns }